import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";
import { Card } from "../onboarding/adminUi";
import { fmtDate } from "../leads/PriorityBadge";
import { WEEKDAYS } from "./MacroTable";

const KIND = { generated: "Generada por IA", edit: "Edición", approved: "Aprobada", rejected: "Rechazada" };
const short = (d) => (d?.meals ? d.meals.map((m) => `${m.time} ${m.name}: ${m.foods.map((f) => `${f.food} ${f.qty}`).join(", ")}`).join("\n") : JSON.stringify(d));

export const GuideHistory = ({ rid, items }) => {
  const [open, setOpen] = useState(null);
  const view = (h) => (h.kind !== "edit" ? null : open?.id === h.id ? setOpen(null) : api.get(`/admin/plan-reviews/${rid}/nutrition/guide/history/${h.id}`).then((r) => setOpen(r.data)).catch((e) => toast.error(formatErr(e))));
  if (!items?.length) return null;
  return (
    <Card title="Historial de cambios de la guía" testid="adv-guide-history">
      {items.map((h) => (
        <div key={h.id} style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "6px 0", fontSize: 12 }} data-testid={`adv-history-${h.id}`}>
          <button onClick={() => view(h)} style={{ background: "none", border: "none", color: "#e5e5e5", cursor: h.kind === "edit" ? "pointer" : "default", padding: 0, textAlign: "left" }}>
            <b>{KIND[h.kind] || h.kind}</b>{h.week !== null && h.week !== undefined ? ` · Semana ${h.week + 1} ${WEEKDAYS[h.weekday]}` : ""} · {h.by_name || "—"} · {fmtDate(h.at)}{h.comment ? ` — ${h.comment}` : ""}
          </button>
          {open?.id === h.id && h.kind === "edit" && (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 6, whiteSpace: "pre-wrap", color: "#a3a3a3" }}>
              <div><b>Antes</b><br />{short(open.before)}</div><div><b>Después</b><br />{short(open.after)}</div>
            </div>
          )}
        </div>
      ))}
    </Card>
  );
};
